// removed by extract-text-webpack-plugin
module.exports = {"NormalBackButton":"NormalBackButton__3mXe1","MobileBackButton":"MobileBackButton__2PXZ9"};


//////////////////
// WEBPACK FOOTER
// ./components/Buttons/BackButton/style.scss
// module id = ApQG
// module chunks = 0